import React, { Suspense, lazy } from 'react';
import {
    Page,
    Col,
    Row,
    Card,
    CardContent,
    Icon,
    BlockTitle,
    Block,
    Link,
    List,
    ListItem,
    Preloader
} from 'framework7-react';
import PageBlock from '../../../shared/pageBlock/pageBlock';
import LanguageSelector from '../../../shared/i18nLanguageSelector/languageSelector';

import { withTranslation } from 'react-i18next';

import EventInfoCard from '../../shared/eventInfoCard/eventInfoCard';
import EnterDataCard from '../../shared/enterDataCard/enterDataCard';
import EicSmall from '../../shared/eventInfoCard/eic-small';
import EnterSpecialCode from '../../shared/enterSpecialCode/enterSpecialCode';

import {formateTimestamp} from '../../../../functions';

const GroupRegistration = lazy(() => import('../../shared/groupRegistration/groupRegistration'));

class Ev1La1 extends React.Component {
    
    state = {
        current_time: Math.round(Date.now()/1000),
        send_data: false,
        group_signup: false,
        view_group_option: true,
        loading_brreg: true,
        brreg: false
    }

    view_group_option = (opt) => {
        this.setState({view_group_option:opt});
    }

    componentDidMount = () => {
        if(this.props.data && this.props.data.org_customer_contact && this.props.data.org_customer_contact.org_nr){
            this.get_data_from_brreg(this.props.data.org_customer_contact.org_nr);
        }
    }

    get_data_from_brreg = (org_nr) => {

        fetch(`https://data.brreg.no/enhetsregisteret/api/enheter/${org_nr}`, {
            method: 'GET',
            headers : new Headers(),
            })
            .then(res => res.json())
            .then(
            (result) => {
                if(result.organisasjonsnummer){


                    this.setState({
                        loading_brreg: false,
                        brreg: true,
                        org_nr: result.organisasjonsnummer,
                        org_name: result.navn,
                        org_adr: result.forretningsadresse.adresse.join(', '),
                        org_zip_code: result.forretningsadresse.postnummer,
                        org_zip_city: result.forretningsadresse.poststed,
                        org_type: result.organisasjonsnummer.beskrivelse
                    });
                    if(result.hjemmeside){
                        this.setState({web_page:result.hjemmeside});
                    }
                }else{
                    this.setState({
                        loading_brreg: false,
                        brreg: false,
                    }); 
                }

            }).catch(err => {
                this.setState({
                    loading_brreg: false,
                    brreg: false,
                });
            })
    }

    render_ticket_bottombar = () => {
        const { t } = this.props;
        return <>
        {!this.state.loading_brreg &&
            <PageBlock width="700px" color="#dfe4ea">
                {(this.props.data.org_customer_contact.customer_contact_email || this.props.data.org_customer_contact.customer_contact_tel) &&
                <>
                <BlockTitle>
                    Kundestøtte
                </BlockTitle>
                <Block>
                    <p>
                    For spørsmål knyttet til arrangementet, ta kontakt med:
                    </p>
                    <b>
                    {this.props.data.org_customer_contact.customer_contact_tel  &&
                    <p>
                    Telefon: {this.props.data.org_customer_contact.customer_contact_tel}
                    </p>
                    }
                    {this.props.data.org_customer_contact.customer_contact_email &&
                    <p>
                    E-post: {this.props.data.org_customer_contact.customer_contact_email}
                    </p>
                    }
                    </b>
                </Block>
                </>
                }
                {this.state.org_name &&
                <>
                        <BlockTitle>Om arrangøren</BlockTitle>
                        <Block>
                            <p>
                            Arrangørens juridiske navn er <b>{this.state.org_name}</b> (org.nr. {this.state.org_nr}).
                            </p>
                        </Block>
                </>
                }
                {this.props.data.org_sales_terms&&
                <>
                    <BlockTitle>
                        {this.state.org_name?this.state.org_name:'Arrangøren'} sine salgs- og påmeldingsvilkår
                    </BlockTitle>
                    <Block>
                        <p>
                        <a href={'./salgsvilkar'}>{this.state.org_name?this.state.org_name:'Arrangøren'} sine salgs og påmeldingsvilkår som gjelder når du melder deg på {this.props.data.title}.</a>
                        </p>
                    </Block>
                </>
                }
                {this.state.brreg &&
                <>
                <BlockTitle>
                    Besøksadresse
                </BlockTitle>
                <Block>
                    <p>
                    {this.state.org_name} holder til: <b>{this.state.org_adr}, {this.state.org_zip_code} {this.state.org_zip_city}</b>
                    </p>
                </Block>
                </>
                }
                <br/>
            </PageBlock>
        }
        <PageBlock width="700px" className="card-background-light signup-bottom-bar">
        <Row noGap>
          <Col width="100" small="40">
              <BlockTitle>Vilkår og personvern</BlockTitle>
              <Block>
                <p style={{marginTop:'-8px'}}>
                <Link external target={'_blank'} href="/cookies">
                Informasjonskapsler (Cookies)
                </Link>
                </p>
                <p style={{marginTop:'-8px'}}>
                <Link external target={'_blank'} href="/vilkar-for-deltakere">
                Vilkår for deltakere
                </Link>
                </p>
                <p style={{marginTop:'-8px'}}>
                <Link external target={'_blank'} href="/personvern">
                Personvernerklæring
                </Link>
                </p>
            </Block>
          </Col>
          <Col width="100" small="60">
            <BlockTitle>Bruk Påmeldinger.no på ditt arrangement!</BlockTitle>
            <Block>
                <p>
                Påmeldinger.no er et påmeldingssystem for konferanser, kurs, konserter og events. Vi håndterer betaling og administrativt arbeid i forbindelse med arrangementer.
                </p>
                <Link href="/" external target={'_blank'}>
                  <b>Les mer om Påmeldinger.no</b>
                </Link>
              </Block> 
            </Col>
          </Row>
        </PageBlock>
        </>;
    }

    save_ticket_exist = (v, id) => {
        for (var i = 0; i < v.length; ++i) {
            if (v[i].eid == id) {
                return v[i];
            }
        }
        return false;
    }

    preview_existing_ticket = () => {
        const { t } = this.props;
        const eid = this.props.eid;
        const registrations = JSON.parse(localStorage.getItem("registrations"));
        if(registrations){
            let ticket = this.save_ticket_exist(registrations, eid);
            if(ticket){
                return <>
                    <Card>
                        <List mediaList>
                            <ListItem
                                link={`/t/${ticket.tid}`}
                                title={t('existing_ticket.goto_existing_ticket')}
                                text={<span dangerouslySetInnerHTML={{__html: t('existing_ticket.existing_ticket_info')}}/>}
                            >
                                <Icon slot="media" f7="qrcode" size={42}></Icon>
                            </ListItem>
                        </List>
                    </Card>
                    <Block style={{opacity:'.6',margin:'auto 12px'}}>
                        <p><i>{t('existing_ticket.existing_ticket_irrelevant')}</i></p>
                    </Block>
                </>;
            }
        }

    }

    render() {
        const { t } = this.props;
        return (
            <Page>
                <PageBlock width="920px">
                <LanguageSelector/>
                <Row>
                    <Col width="100" medium="40" style={{maxWidth:'440px',marginLeft:'auto',marginRight:'auto'}}>
                        <EventInfoCard data={this.props.data}/>
                        <EicSmall data={this.props.data}/>
                        {this.props.data.special_col_exist === true &&
                        <EnterSpecialCode data={this.props.data} reload_event={this.props.reload_event.bind(this)}/>
                        }
                        <br className="hideFullScreen"/>
                    </Col>
                    <Col width="100" medium="60" style={{maxWidth:'540px',marginLeft:'auto',marginRight:'auto'}}>
                        {this.preview_existing_ticket()}
                        {this.props.data.full && this.props.data.available_for_registration && (
                            this.props.data.options.waiting_list === 1 ?
                            <Card outline style={{backgroundColor:'#dfe4ea'}}>
                                <CardContent>
                                    <p>{t('warnings.event_is_full_waiting_available')}</p>
                                </CardContent>
                            </Card>
                            :
                            <Card style={{color:'#fff', backgroundColor:'#e74c3c'}}>
                                <CardContent>
                                    <Icon material="error" style={{marginRight:'12px',marginTop:'-5px'}}/>
                                    <span style={{fontSize:'18px'}}>
                                    {t('warnings.event_is_full')}
                                    </span>
                                </CardContent>
                            </Card>
                            )
                        }
                        {this.props.data.available_for_registration ?
                        <>
                        {(this.props.data.options.allow_group === 1 && this.state.view_group_option) ?
                            <>
                            <BlockTitle style={{marginTop:'24px'}} medium>{t('sign_up.sign_up_for')} <b>{this.props.data.title}</b></BlockTitle>
                            <Block style={{marginBottom:'18px'}}>
                                <p>
                                {t('sign_up.fill_out_form_to_sign_up')}
                                </p>
                            </Block>
                            <Suspense fallback={<div className="text-align-center" style={{marginTop:'36px',marginBottom:'160px'}}><Preloader></Preloader></div>}>
                                <GroupRegistration data={this.props.data}/>
                            </Suspense>
                            </>
                        :
                            <EnterDataCard data={this.props.data} view_group_option={this.view_group_option.bind()}/>
                        }
                        </>
                        :
                        <>
                        <Card style={{color:'#fff', backgroundColor:'#e74c3c'}}>
                            <CardContent>
                                <Icon material="error" style={{marginRight:'12px',marginTop:'-5px'}}/>
                                <span style={{fontSize:'18px'}}>{t('warnings.you_cannot_sign_up')}</span>
                            </CardContent>
                        </Card>

                        {this.props.data.singup_periode.start > this.state.current_time && (
                            <Card>
                                <CardContent>
                                    <span style={{fontSize:'16px'}} dangerouslySetInnerHTML={
                                        {__html: t('warnings.sign_up_time_start', {date_time: formateTimestamp(this.props.data.singup_periode.start)})}
                                    }/>
                                </CardContent>
                            </Card>
                        )}
                        {this.props.data.singup_periode.end < this.state.current_time && (
                            <Card>
                                <CardContent>
                                    <span style={{fontSize:'16px'}} dangerouslySetInnerHTML={
                                        {__html: t('warnings.sign_up_deadline_expired', {date_time: formateTimestamp(this.props.data.singup_periode.end)})}
                                    }/>
                                </CardContent>
                            </Card>
                        )}

                        </>
                        }
                    </Col>
                </Row>
                </PageBlock>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                {this.render_ticket_bottombar()}
            </Page>
        );
    }
};
export default withTranslation()(Ev1La1);